export default __webpack_public_path__ + "static/media/avatar-michi.f01c64bf.png";